<div class="bg-lightest flex flex-col p-3 w-full flex-grow overflow-hidden">
  <div class="py-10 flex justify-between w-full">
    <h1 class="flex items-center text-xl font-app-bold">
      {{ "homePage.home" | translate }}
    </h1>
  </div>
  <div class="flex flex-col md:flex-row justify-between w-full">
    <div class="md:w-7/12 md:ml-4 w-full">
      <app-contract
        [ngClass]="{
          hidden: policies.length === 0,
          block: policies.length > 0,
        }"
        [openAccordion]="openAccordionPolicies"
        [contracts]="policies"></app-contract>
      <app-quotation [quotations]="quotations"></app-quotation>
    </div>
  </div>
</div>

